<template>
  <div v-if="definition">
    <ux-button color="primary" @click="openModal"
      >Include additional {{ definition.title }} fields <ux-icon icon="fa-plus"
    /></ux-button>
  </div>
</template>
<script>
import DefinedFieldSelectModal from "./modals/DefinedFieldSelectModal.vue";
export default {
  props: {
    modelValue: {
      type: Object,
    },
    referenceType: {
      type: String,
    },
  },
  data() {
    return {
      model: this.modelValue,
    };
  },
  watch: {
    referenceType: {
      async handler(referenceType) {
        if (referenceType) {
          await this.$glossary.ensure(referenceType);
        }
      },
      immediate: true,
    },
  },
  computed: {
    glossary() {
      return this.$glossary.hash;
    },
    definition() {
      return this.glossary[this.referenceType];
    },
  },
  inject: {
    addFields: {
      default() {
        return;
      },
    },
  },
  methods: {
    async openModal() {
      const self = this;

      const result = await self.$sdk.modal({
        component: DefinedFieldSelectModal,
        options: {
          definition: self.definition,
        },
      });

      if (result.length) {
        // self.model.fields = [...(self.model.fields || []), ...result];
        // console.log('Selected', result);

        // self.$emit('updated:modelValue', self.model)
        if (self.addFields) {
          self.addFields(result);
        }
      }
    },
  },
};
</script>
